import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const ExtraText = styled.span`
  font-size: 15px;
  color: ${({ theme }) => theme.defaultColors.fontSecondary};
  margin-bottom: 3px;
`;

export const ExtraContainer = styled.div`
  display: grid;
  grid-template-columns: 50% auto;
  gap: 20px;
`;

export const ExtraPrice = styled(ExtraText)`
  padding: 0 5px;
  text-align: right;

  ${media.md`
    text-align: left;
  `}
`;
